import { render, staticRenderFns } from "./Suggested.vue?vue&type=template&id=5971376a&scoped=true"
import script from "./Suggested.vue?vue&type=script&lang=js"
export * from "./Suggested.vue?vue&type=script&lang=js"
import style0 from "./Suggested.vue?vue&type=style&index=0&id=5971376a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5971376a",
  null
  
)

export default component.exports